export const tabA11yProps = (index: number, prefix: string) => ({
  id: `${prefix}-${index}`,
  'aria-controls': `${prefix}panel-${index}`,
});

export const TabPanel: React.FC<TabPanelProps> = (props: TabPanelProps) => {
  const {
    children, className, value, index, prefix, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${prefix}panel-${index}`}
      aria-labelledby={`${prefix}-${index}`}
      className={className}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
};
